var TooltipInit;

(function ($) {

	const selectors = {
		box: '[data-tooltip]',
		content: '[data-tooltip-content]'
	}


	TooltipInit = class TooltipInit {
		constructor() {
			this.init();
		}
		init() {
			$(selectors.box).each((i, el) => {
				new Tooltip(el);
			})
		}
	}

	class Tooltip {
		constructor(element) {
			this.box = element;

			if ($(this.box).length) {
				this.init();
				this.bind();
			}


		}
		init() {
			this.$content = $(selectors.content, this.box);
		}
		bind() {

			this.onMouseEnter = this.onMouseEnter.bind(this);
			this.onMouseOut = this.onMouseOut.bind(this);

			$(this.box).hover(this.onMouseEnter, this.onMouseOut);

		}

		onMouseEnter() {
			this.$content.stop().fadeIn();
		}

		onMouseOut() {
			this.$content.stop().fadeOut();
		}

	}

})(jQuery);


export default TooltipInit;